// ** React Imports
import {useEffect, useState} from 'react'

// ** MUI Imports
import Step from '@mui/material/Step'
import Stepper from '@mui/material/Stepper'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'

// ** Step Components
import StepPersonalInfo from "./StepPersonalInfo";

// ** Custom Component Import
import StepperCustomDot from 'src/views/forms/form-wizard/StepperCustomDot'

// ** Styled Components
import StepperWrapper from 'src/@core/styles/mui/stepper'
import StepCredentialsInfo from "./StepCredentialsInfo";
import StepConfirmation from "./StepConfirmation";


import {FormProvider, useForm} from "react-hook-form";
import {SignupFields, SignupSend} from "../../../../types/user/authData";
import {HttpOnboardingAuth} from "../../../../http/onboarding/httpOnboardingAuth";
import * as yup from "yup";
import {
  PhoneNumberSchema,
  RequiredSchema,
  RequiredStringSchema
} from "../../../../utils/validations";
import {yupResolver} from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import useAxios from "../../../../hooks/useAxios";

const steps = [
  {
    title: 'Personal',
  },
  {
    title: 'Credenciales',
  },
  {
    title: 'Confirmación'
  }
]

const RegisterMultiSteps = () => {
  // ** States
  const [activeStep, setActiveStep] = useState<number>(0)
  const {fetchData} = useAxios()
  const registerSchema = yup.object().shape({
    [SignupFields.Nombre]: RequiredStringSchema,
    [SignupFields.Apellido]: RequiredStringSchema,
    [SignupFields.DNI]: RequiredSchema,
    [SignupFields.Genero]: RequiredSchema,
    [SignupFields.Cargo]: RequiredSchema,
    [SignupFields.TipoCelular]: RequiredSchema,
    [SignupFields.CodArea]: RequiredSchema,
    [SignupFields.Telefono]: PhoneNumberSchema.required('Campo obligatorio')
  })
  
  
  const methods = useForm<SignupSend>({
    resolver: yupResolver(registerSchema)
  })
  
  // Handle Stepper
  const handleNext = () => {
    setActiveStep(activeStep + 1)
  }
  const handlePrev = () => {
    if (activeStep !== 0) {
      setActiveStep(activeStep - 1)
    }
  }

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <StepPersonalInfo handleNext={handleNext} />
      case 1:
        return <StepCredentialsInfo handlePrev={handlePrev}/>
      case 2:
        return <StepConfirmation />
      
      default:
        return null
    }
  }

  const renderContent = () => {
    return getStepContent(activeStep)
  }

  const onSubmit = (data: SignupSend) => {
    fetchData(() => HttpOnboardingAuth.register(data), true)
        .then(() => {
          handleNext()
        })
  }

  useEffect(() => {
    if (methods.formState.errors[SignupFields.DNI] || methods.formState.errors[SignupFields.Nombre] ||
        methods.formState.errors[SignupFields.Apellido] || methods.formState.errors[SignupFields.Cargo] || 
        methods.formState.errors[SignupFields.CodArea] || methods.formState.errors[SignupFields.Genero] || 
        methods.formState.errors[SignupFields.TipoCelular] || methods.formState.errors[SignupFields.Telefono])
      toast.error('Verifique los campos del paso anterior para continuar')
  }, [methods.formState.errors]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <StepperWrapper sx={{ mb: 10 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((step, index) => {
              return (
                <Step key={index}>
                  <StepLabel StepIconComponent={StepperCustomDot}>
                    <div className='step-label'>
                      <Typography className='step-number'>{`0${index + 1}`}</Typography>
                      <div>
                        <Typography className='step-title'>{step.title}</Typography>
                      </div>
                    </div>
                  </StepLabel>
                </Step>
              )
            })}
          </Stepper>
        </StepperWrapper>
        {renderContent()}
      </form>
    </FormProvider>
  )
}

export default RegisterMultiSteps
